import { FadeTransition } from "./components/FadeTransition"
import { GlobalView, useGlobalView } from "./store/view"
import Main from "./topics/Main"
import Recall from "./topics/Recall"

const App: React.FC = () => {
    const globalView = useGlobalView()
    return (
        <>
            {globalView === GlobalView.RECALL ? <Recall /> : <Main />}
            <FadeTransition scope="full" />
        </>
    )
}

export default App
